import { atom, useAtom } from "jotai";

export const perpIsBuyAtom = atom<boolean>(true);

export const usePerpIsBuy = () => {
  const [perpIsBuy, setPerpIsBuy] = useAtom(perpIsBuyAtom);

  return {
    perpIsBuy,
    setPerpIsBuy,
  };
};
